import { Injectable } from '@angular/core';
import {AuthedApiService} from './authed-api.service';
import {environment} from '../environments/environment';
import {Router} from '@angular/router';

export interface LogEvent {
  logType: string;
  logLevel: number;
  slugPath: string;
  slugSearch: string;
  label: string;
  featureArea: string;
  resource: string;
  action: string;
  result: string;
  payload: object;
  responseStatusCode: number;
  response: object;
  errorMessage: string;
  logMessage: string;
}
@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

  constructor(private authedApi: AuthedApiService, private router: Router) { }

  log(logEvent) {
    const log_payload: LogEvent = {
      logType: logEvent['logType'],
      logLevel: logEvent['logLevel'],
      slugPath: this.router.url,
      slugSearch: logEvent['slugSearch'],
      label: logEvent['label'],
      featureArea: logEvent['featureArea'],
      resource: logEvent['resource'],
      action: logEvent['action'],
      result: logEvent['result'],
      payload: logEvent['payload'],
      responseStatusCode: logEvent['responseStatusCode'],
      response: logEvent['response'],
      errorMessage: logEvent['errorMessage'],
      logMessage: logEvent['logMessage']
    };
    this.authedApi.postCoreApi(environment.coreAPI.log.name, environment.coreAPI.log.version, log_payload).subscribe(res => {
    });
  }
}
